import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { LEGAL_LINKS } from '../data/legalLinks';
import {
  hasConsentChoice,
  saveCookieConsent,
} from '../lib/cookieConsent';
import { loadYandexMetrika } from '../lib/yandexMetrika';

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!hasConsentChoice());
  }, []);

  const acceptAnalytics = async () => {
    saveCookieConsent(true);
    setVisible(false);
    await loadYandexMetrika({ webvisor: true, clickmap: true });
  };

  const acceptEssentialOnly = () => {
    saveCookieConsent(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-[100] p-4 md:p-6"
      role="dialog"
      aria-label="Согласие на cookies"
    >
      <div className="mx-auto max-w-3xl rounded-lg border border-border bg-card shadow-lg p-4 md:p-5">
        <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
          Мы используем обязательные cookies для работы сайта и корзины. Аналитика (Яндекс.Метрика,
          карта кликов и вебвизор) подключается только с вашего согласия.{' '}
          <Link to={LEGAL_LINKS.cookies} className="text-accent hover:underline">
            Подробнее
          </Link>
        </p>
        <div className="flex flex-col sm:flex-row gap-2 sm:justify-end">
          <Button type="button" variant="outline" onClick={acceptEssentialOnly}>
            Только необходимые
          </Button>
          <Button type="button" onClick={acceptAnalytics}>
            Принять аналитику
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
